import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { generateURL } from '../../routes';
import { formatNumber, DateFormatter } from '../../utils/date';
import tryActivateElem from '../timeline/scrollActivate';
import Clamp from 'react-clamp';
import css from './timelineEditorial.scss';

import img1 from './case-1.png';
import img2 from './case-2.png';
import img3 from './case-3.png';
import img4 from './case-4.png';

export default class EditorialArticleElement extends Component {
	static propTypes = {
		profiles: PropTypes.array.isRequired,
		createdDate: PropTypes.string.isRequired,
		categories: PropTypes.array.isRequired,
		title: PropTypes.string.isRequired,
		image: PropTypes.oneOfType([
			PropTypes.object.isRequired,
			PropTypes.oneOf([false]),
		]),
		browser: PropTypes.object.isRequired,
		types: PropTypes.object.isRequired,
		excerpt: PropTypes.string.isRequired,
		users: PropTypes.object.isRequired,
		className: PropTypes.string,
		sortDate: PropTypes.string.isRequired,
		same: PropTypes.string.isRequired,
	};

	static defaultProps = {
		points: 0,
		profiles: [],
		createdDate: '',
		categories: [],
		title: 'Unknown',
		image: '',
		excerpt: '',
		className: '',
	};

	constructor(props) {
		super(props);

		//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
		this.state = {
			clamped: false,
		};
	}

	componentDidMount() {
		this.tryActivateElem = tryActivateElem(this.getElement.bind(this), this.props.browser);
		if (!this.tryActivateElem()) {
			this.props.browser.scroll.register(this.tryActivateElem);
		}
		
		if (!this.state.clamped) {
			this.setState({
				clamped: true,
			});
		}
	}

	componentWillUnmount() {
		this.props.browser.scroll.deregister(this.tryActivateElem);
	}

	shouldComponentUpdate(nProps, nState) {
		return (
			nState !== this.state ||
			nProps.browser.window.width !== this.props.browser.window.width ||
			nProps.createdDate !== this.props.createdDate ||
			nProps.title !== this.props.title || 
			nProps.className !== this.props.className || 
			nProps.browser.window.width !== this.props.browser.window.width
		);
	}

	render() {
		//let { title, categories, profiles, points, createdDate } = this.props.item;
		let createdDate = new DateFormatter(this.props.sortDate);
		let winDate = new DateFormatter(); //@TODO set real winDate
		let awardType = 'FWA of the Day';

		let smallTitle = '';

		let month = createdDate.month;

		if (this.props.browser.window.width < 1200 && this.props.browser.window.width > 719) {
			month = createdDate.monthShort;
		}

		if (this.props.types.seriesName != '') {
			smallTitle = this.props.types.seriesName;
		} else {
			smallTitle = this.props.types.name;
		}

		let byText = 'by ';

		if (this.props.users.name) {
			byText += this.props.users.name;
		} else {
			byText += 'John Doe';
		}

		this.slides = this.props.image;

		return (
			<li className={'timeline__element span6 span12-mobile ' + this.props.className + ' ' + this.props.same} ref='timelineElement'>
				<time className='timeline-editorial__date span1 span4-mobile'>
					<span className='timeline-editorial__date--day'>{createdDate.date}</span>
					<span className='timeline-editorial__date--month'>{month}</span>
				</time>
				<Link to={generateURL(this.props.types.slug, this.props.slug)} className='timeline-editorial' ref='timelineEditorial'>
					<div className='timeline-editorial__interview clearfix span6 span12-mobile'>
						<h3 className='timeline-editorial__interview-type'>{smallTitle}</h3>
						<div className='span6 span4-tablet span12-mobile timeline-editorial__interview-description'>
							<h2 className='timeline-editorial__article-title span6-mobile'>
								<Clamp ref='clampText' clamp={4} ellipsis="…">
								{this.props.title}
								</Clamp>
							</h2>
							<div className='timeline-editorial__interview-profile'>{byText}</div>
						</div>
					</div>
					<div className='timeline-editorial__interview__details push2-mobile push1'>
						<div className='button button--dark'>Read Article</div>
					</div>
				</Link>
			</li>
		);
	}

	getCategoryName(categories) {
		let cat = '';
		if (categories && typeof categories === 'object' && categories.length) {
			cat = categories.slice(0, 1).map((item) => {
				return item.name;
			});
		}

		return cat;
	}

	getElement() {
		return this.refs.timelineElement;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/timelineeditorial/timelineEditorialArticle.js
 **/